 <div class="fixed inset-0 bg-gray-600 bg-opacity-60 z-30 flex items-center justify-center">
    <div class="bg-white rounded-lg p-4 w-full max-w-[450px]">
        <h1 class="font-semibold text-lg pb-2">Delete Confirmation</h1>
        <hr>
        <div class="py-4">
            <p class="text-gray-700">{{message}}</p>
        </div>
        <div class="flex mt-2 justify-end">
            <outline-button text="Cancel" (click)="onCancel()" [marginRight]="true" />
            <full-button text="Confirm" (click)="onConfirm()" />
        </div>
    </div>
</div>
